import { whiteColor, primaryColor, blackColors } from 'assets/jss/material-dashboard-pro-react';
import customSelectorsStyle from './customSelectorsStyle';

const customCheckboxStyle = {
	...customSelectorsStyle,
	checkedIcon: {
		width: '24px',
		height: '24px',
		color: whiteColor,
		backgroundColor: primaryColor[0],
		borderRadius: '4px',
	},
	iconDisabled: {
		backgroundColor: `${blackColors[6]} !important`,
	},
	indeterminateIcon: {
		width: '24px',
		height: '24px',
		backgroundColor: primaryColor[0],
		borderRadius: '4px',
		color: whiteColor,
	},
	uncheckedIcon: {
		width: '0px',
		height: '0px',
		padding: '11px',
		border: '1px solid ' + blackColors[4],
		backgroundColor: blackColors[6],
		borderRadius: '4px',
	},
	checked: {
		color: primaryColor[0] + '!important',
	},
	radioChecked: {},
	radioUnchecked: {},
	rootSm: {
		'& .MuiButtonBase-root': {
			padding: '12px',
			'&.Mui-checked': {
				'& .MuiIconButton-label': {
					'& svg': {
						padding: 0,
						width: '16px',
						height: '16px',
					},
				},
			},
			'& .MuiIconButton-label': {
				'& svg': {
					padding: '7px',
				},
			},
		},
		'& .MuiTypography-root.MuiFormControlLabel-label': {
			bottom: '-1px',
		},
	},
	rootXs: {
		'& .MuiButtonBase-root': {
			'&.Mui-checked': {
				'& .MuiIconButton-label': {
					'& svg': {
						padding: 0,
						width: '12px',
						height: '12px',
					},
				},
			},
		},
	},
	uncheckedIconXs: {
		padding: '6px',
	},
};

export default customCheckboxStyle;
